import React from "react";
import { SubscriptionPlanCardTemplate } from "themes/application/payment/components";

function SubscriptionPlanCard(props) {
    return <SubscriptionPlanCardTemplate {...props} />;
}

export default SubscriptionPlanCard;
